import materaSignature10_1 from "./materaSignature10 (10).png";
import materaSignature10_2 from "./materaSignature10 (12).png";
import materaSignature10_3 from "./materaSignature10 (13).png";
import materaSignature10_4 from "./materaSignature10 (14).png";
import materaSignature10_5 from "./materaSignature10 (15).png";
import materaSignature10_6 from "./materaSignature10 (16).png";
import materaSignature10_7 from "./materaSignature10 (17).png";
import materaSignature10_8 from "./materaSignature10 (18).png";
import materaSignature10_9 from "./materaSignature10 (19).png";
import materaSignature10_10 from "./materaSignature10 (20).png";
import materaSignature10_11 from "./materaSignature10 (21).png";
import materaSignature10_12 from "./materaSignature10 (22).png";
import materaSignature10_13 from "./materaSignature10 (23).png";

const materaSignature10 = [
  materaSignature10_1,
  materaSignature10_2,
  materaSignature10_3,
  materaSignature10_4,
  materaSignature10_5,
  materaSignature10_6,
  materaSignature10_7,
  materaSignature10_8,
  materaSignature10_9,
  materaSignature10_10,
  materaSignature10_11,
  materaSignature10_12,
  materaSignature10_13,
];

export default materaSignature10;
